jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        setTimeout(initGa, 2000);
        function initGa(){

            // TRAC JOB category Click
            $('body').on('click', '#hj-select-sector ul li > a', function(e){
                var link = $(this).attr('href'),
                    title = $(this).attr('title');
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobCategoryClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobCategoryClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobCategoryClick', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
              //  console.log('JobCategoryClick: '+title + ' => '+link);
            });

            // TRAC Single Job Click
            $('body').on('click', '#hj-job-list ol li > a', function(e) {
                var link = $(this).attr('href'),
                    title = $(this).attr('title');
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobClick', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
              //  console.log('JobClick: '+title + ' => '+link);
            });

            // TRAC Apply click
            $('body').on('click', '#hj-job a.hj-apply-online', function(e) {
                e.preventDefault();
                var link = $(this).attr('href'),
                    title = $('.hj-job-title h2').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobApply',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobApply'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobApply', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
               // console.log('JobApply: '+title + ' => '+link);
                window.open(link, "_blank");
            });

            // Internal JOB category Click
            $('body').on('click', '.fcl_image_block_landing a', function(e) {
                var link = $(this).attr('href'),
                    title = $(this).find('.title').text();
                // Block not being used for vacancies
                if ( link.indexOf('vacancies') < 0 ) {
                    return true;
                }
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobCategoryClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobCategoryClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobCategoryClick', {
                        'event_category' : 'internalVacancies',
                        'event_label' : title
                    });
                }
                //console.log('JobCategoryClick: '+title + ' => '+link);
            });
            // Internal JOB subcategory Click
            $('body').on('click', '.vacancy-landing .subcats a', function(e) {
                var link = $(this).attr('href'),
                    title = $(this).find('h4').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobCategoryClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobCategoryClick'
                    });
                }
                if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobCategoryClick', {
                        'event_category' : 'internalVacancies',
                        'event_label' : title
                    });
                }
                //console.log('JobCategoryClick sub: '+title + ' => '+link);
            });

            // Internal Single Job Click
            $('body').on('click', '.vacancy-results .result a', function(e) {
                var link = $(this).attr('href'),
                    title = $(this).closest('.result').find('.title').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobClick', {
                        'event_category' : 'internalVacancies',
                        'event_label' : title
                    });
                }
                //console.log('JobClick: '+title + ' => '+link);
            });

            // Internal Apply click (submit button only)
            $('body').on('click', '.vacancy-apply form input[type=submit], .vacancy-apply form button[type=submit]', function(e) {
                //e.preventDefault();
                var link = window.location.href,
                    title = $('.content').find('.page-title:first').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobApply',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobApply'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobApply', {
                        'event_category' : 'internalVacancies',
                        'event_label' : title
                    });
                }
                //console.log('JobApply: '+title + ' => '+link);
                //window.open(link, "_blank");
            });

            // Add a parameter to apply form to help with tracking
            if ( $('.vacancy-apply form').length > 0 ) {
                var action = $('.vacancy-apply form').attr('action');
                if ( action.indexOf('?') >= 0 ) {
                    action += '&applied=1';
                } else {
                    action += '?applied=1';
                }
                $('.vacancy-apply form').attr('action', action);
            }
            // Internal Applied (when form has submitted successfully)
            if ( $('.vacancy-apply .callout.success, .vacancy-apply .gform_confirmation_message').length > 0 && window.location.search.indexOf('applied=1') >= 0 ) {
                //e.preventDefault();
                var link = window.location.href,
                    title = $('.content').find('.page-title:first').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobApplySuccess',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobApplySuccess'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobApplySuccess', {
                        'event_category' : 'internalVacancies',
                        'event_label' : title
                    });
                }
                //console.log('JobApplySuccess: '+title + ' => '+link);
                //window.open(link, "_blank");
            }

        }
        //Document Ready ENDS
    });
})(jQuery);